import store from "store/store";
import { budgetBuilderSelectors, shellSelectors } from "store/selectors";

import { budgetFactory } from "./actions";
import { loadCaseInstance } from "./caseInstance";
import { loadBudgetBuilder } from "./budgetBuilder";
import { setCurrentVersion } from './actions';
import { api } from "services";


export const createNewVersion = async note => {
	const state = store.getState();
	const personId = shellSelectors.user(state).personId;
	const startNewVersionTaskId = budgetBuilderSelectors.startNewVersionTaskId(state);

	budgetFactory.setIsFetching(true);

	await api.tasks.saveBudgetBuilderTask(
		{ id: startNewVersionTaskId },
		{ note, personId },
	);

	return loadBudgetBuilder(false);
};

export const rollbackToCurrentVersion = async () => {
	const state = store.getState();
	const personId = shellSelectors.user(state).personId;
	const currentVersion = budgetBuilderSelectors.currentVersion(state);
	const taskId = budgetBuilderSelectors.rollbackToVersionTaskId(state);

	if (!currentVersion?.caseInstanceId) {
		return Promise.resolve();
	}

	await api.tasks.saveBudgetBuilderTask(
		{ id: taskId },
		{ personId, selectedVersion: currentVersion.caseInstanceId, note: null },
	);

	await clearCurrentVersion();
};

export const clearCurrentVersion = async () => {
	await loadBudgetBuilder();

	setCurrentVersion(null);
};

// todo: add fetching state?

export const loadVersion = async version => {
	await loadCaseInstance({
		caseInstanceId: version?.caseInstanceId,
		budgetType: null,
		isRefresh: false,
		fromRoot: false,
	});

	setCurrentVersion(version);
};
